export const ANNOTATIONS_DATE_FORMAT = "yyyy-MM-dd";
